/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![HomeSlashIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABj0lEQVR4nM2Vu0oDQRSG1wvYaKeNpYKlnaVEC2HVPZcVNuckjW+gnWi1aa3NW+QJgoWgWCqk8wHEVixFYuSEJCbuPRfwwIEZ9p/vn52ZM+M4/yVc110C1lNLayfpPK+yiqRNZLnODWeWTWB5RtaOpbWPT6obsXCWVldH2swFBxYClvc+fMjkHXw9iIWztKyfCi6VSov2m8j6/Rf+m3I+FtwNgjVgvU0GdzPsawvBiWQXSN5mAZ8D0gtk/UqDA0ktbVk8v7xjrBFyEAQLwNLImHUnC27fewegYcyhZanAtODYS6LK0cDAYzmcJhxtjK/uwCAMw3kgqQPp56RwMAbpTWQfumLWq0lnjiyXaUe0mheOvp7FLacxEg0Qy/t54BkGe05SIOIK+mXNU/5ut8iiBsyylWgwOji7QjHGIAiC5anALWI2+MNJi6J3C0aucH1JFCceRdDtAgZ3xeAkNSBp5zYgqUdEdikh6VME3is6YL1PNCB56IHbwPqIqOsRkT3gyPpqJpmPxbhhJvZEzgL+A6LY99NrsWZmAAAAAElFTkSuQmCC)
 */
export const HomeSlashIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M22.7 2.7a1 1 0 0 0-1.4-1.4l-20 20a1 1 0 1 0 1.4 1.4l20-20ZM15.5 3.7a.5.5 0 0 1 .05.75l-10.9 10.9a.5.5 0 0 1-.85-.3l-.27-2.72a.46.46 0 0 0-.35-.4 2 2 0 0 1-.79-3.54l8.39-6.45a2 2 0 0 1 2.44 0L15.5 3.7ZM6.31 22c-.12 0-.17-.14-.08-.23l1.92-1.92a.5.5 0 0 1 .85.36V21a1 1 0 0 1-1 1H6.31ZM14.47 13.53c-.19.19-.19.5-.03.73.35.5.56 1.1.56 1.74v5a1 1 0 0 0 1 1h1.69a2 2 0 0 0 1.99-1.8l.79-7.87c.02-.2.16-.36.35-.4a2 2 0 0 0 .79-3.54l-.78-.6a.5.5 0 0 0-.66.04l-5.7 5.7Z"
        className={colorClass}
      />
    </svg>
  );
};
